const imageNameToClass = [
	["sky", "sky"],
	["skyhaze-left", "hazeL"],
	["skyhaze-right", "hazeR"],
	["clouds-left", "cloudsL"],
	["clouds-left-small", "cloudsLSmall"],
	["clouds-right", "cloudsR"],
	["mountains", "mountains"],
	["hill-range-back", "hillRangeBack"],
	["hill-range-front", "hillRangeFront"],
	["hill-back-left", "hillBackLeft"],
	["hill-back-right", "hillBackRight"],
	["hill-front-left", "hillFrontLeft"],
	["hill-front-right", "hillFrontRight"],
	["hill-center", "hillC"],
	["bush-left", "bushL"],
	["bush-front", "bushFront"],
	["tree-front", "treeFront"],
	["one-tree-left", "oneTreeL"],
	["two-trees-left", "twoTreesL"],
	["five-trees-left", "fiveTreesL"],
	["four-trees-right", "fourTreesR"],
	["six-trees-right", "sixTreesR"],
];

const getBackdropImages = function() {
	return imageNameToClass.map(value => {
		return {
			imageName: value[0],
			style: value[1],
		};
	});
};

module.exports = {
	getBackdropImages,
};
